import { SpecialSymbolGroup } from './special-symbol-group.model';
import { Line } from './line.model';

export class BonusResponse {
  type: string;
  bonusType: string;
  result: BonusResult | null;
  nextRound: BonusRound | null;
  currentRound: BonusRound | null;
  previousRounds: BonusRound[];
  bonusFinished: boolean;
  bonusStarted: boolean;
}

export class BonusResult {
  bonusWin: number;
  totalWin: number;
  specGroups: SpecialSymbolGroup[] | null;
  additionWin: number;
  multiplier: number;
  bet: number;
  lines: number;
  winName: string;
  betCalculation: string;
  winLines: Line[] | null;
}

export class ExtraGain {
  type: string;
  value: number;
}

export class BonusRound {
  notSelectedButtons: RoundButton[];
  selectedButtons: RoundButton[];
  serverSelectedButtons: RoundButton[];
  paytable: PaytableItem[];
  roundType: string;
  roundNumber: number;
  attemps: number;
  attempsUsed: number;
}

export class RoundButton {
  type: string;
  value: number;
  totalValue: number;
  view: string;
  index: number;
  extraValues: ExtraGain[];
  routingIndex: number;
}

export class PaytableItem {
  type: string;
  value: number;
  totalValue: number;
  index: number;
  extraValues: ExtraGain[];
}
